@if (!allAssetsLoaded) {
  <div class="loading-box">
    <app-loading-indicator></app-loading-indicator>
    <span>{{ loadedAssets.length }} / {{ assets?.length || 0 }} assets loaded</span>
  </div>
}
<div
  class="print-overview {{ thumbnailSize }}"
  [style.--asset-size]="assetSize + '%'"
  [class.loading]="!allAssetsLoaded"
  (click)="close()"
>
  @if (gallery.name || gallery.title) {
    <h1>{{ gallery.name || gallery.title }}</h1>
  }
  @if (gallery.description) {
    <h3 [innerHTML]="gallery.description"></h3>
  }
  @if (gallery.name || gallery.title || gallery.description) {
    <div class="title-spacer"></div>
  }
  @for (row of rows; track row) {
    <div class="print-row">
      <div class="assets">
        @for (asset of row; track asset) {
          <div class="asset {{ asset.status }}" #el>
            @if ((asset | canDisplayAsset) && asset.type !== 'audio') {
              <img
                [src]="
                  asset.version_data
                    | assetVersionUrl: asset : asset.version_data.status : 600 : 600 : !!gallery.watermark
                "
                [alt]="asset.version_data.asset_name"
                (load)="assetLoaded(asset)"
                (error)="assetLoaded(asset)"
              />
            } @else {
              <!-- <img
                [src]="asset.version_data | failedAssetVersionUrl: 600 | async"
                [alt]="asset.version_data.asset_name"
                (load)="assetLoaded(asset)"
                (error)="assetLoaded(asset)"
              /> -->

              <app-non-preview-file
                [asset]="asset"
                [gallery]="gallery"
                [showFilename]="true"
                [darkBackground]="false"
                [showBorder]="true"
              ></app-non-preview-file>
            }
            <div class="name-container">
              @if (showFavorites) {
                <div class="favorites">
                  @if (asset.likes) {
                    <app-svg src="/assets/icons/heart-filled.svg" color="warn"></app-svg>
                  }
                  @if (!asset.likes) {
                    <app-svg src="/assets/icons/heart-empty.svg" color="grey-50"></app-svg>
                  }
                  <span>{{ asset.likes }}</span>
                </div>
              }
              <div class="asset-name {{ showStatus ? asset.status : '' }}">
                @if (showStatus) {
                  <app-svg [src]="'/assets/icons/' + (asset.status | assetStatusIcon) + '.svg'"></app-svg>
                }
                @if (showFilename) {
                  <span>{{ asset.version_data.asset_name }}</span>
                }
                @if (!showFilename && showStatus && asset.status !== 'no_status') {
                  <span>{{ asset.status | assetStatusName }}</span>
                }
              </div>
              @if (showColorlabels && asset.color_label) {
                <app-svg
                  src="/assets/icons/color-label-filled.svg"
                  class="labels-icon"
                  [attr.color]="asset.color_label"
                ></app-svg>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
